import { Domain } from 'library/ts/model/enums/web/Domain';
export class FreewheelConstants {
    static _instance = new FreewheelConstants();
    constructor() {
        if (FreewheelConstants._instance) {
            throw new Error(this.name +
                ' is a Singleton and can only be accessed through ' +
                this.name +
                '.getInstance()');
        }
        FreewheelConstants._instance = this;
    }
    get name() {
        return 'FreewheelConstants';
    }
    get scheme() {
        return window.SmartTag.runtimeVO.app.ssl === true ? 'https' : 'http';
    }
    get hostIMA() {
        return '7f077.v.fwmrm.net/ad/g/1';
    }
    get assetNetworkId() {
        return '520311';
    }
    get siteSectionPPlusLive() {
        return 'streaming_paramountplus_ctv_chromecast_live';
    }
    get siteSectionPPlusVOD() {
        return 'streaming_paramountplus_ctv_chromecast_vod';
    }
    get siteSectionCBSLive() {
        return 'vcbs_cbs_ctv_chromecast_live';
    }
    get siteSectionCBSVOD() {
        return 'streaming_paramountplus_ctv_chromecast_vod';
    }
    get capabilitiesFlag() {
        return '+amcb+emcr+sltp+slcb+qtcb+vicb+fbad+sync+nucr+aeti';
    }
    get defaultCapabilities() {
        return '1023';
    }
    get networkId() {
        return '520311';
    }
    get slau() {
        return 'Super Bowl 58';
    }
    get playerProfile() {
        return '520311:GoogleDAICSAI_v01';
    }
    get pageView() {
        return this.randomTag;
    }
    get response() {
        return 'vmap1+vast4';
    }
    get siteSectionNetworkId() {
        return '520311';
    }
    get videoPlayer() {
        return this.randomTag;
    }
    get size() {
        return '640x480';
    }
    get descUrlCBS() {
        return 'https://www.' + Domain.CBSCOM;
    }
    get descUrlPPlus() {
        return 'https://www.' + Domain.PPLUS;
    }
    get randomTag() {
        return '[RANDOM]';
    }
    get durTag() {
        return '[DUR]';
    }
    get midroll() {
        return 'MIDROLL';
    }
    get variable() {
        return 'VARIABLE';
    }
    static getInstance() {
        return FreewheelConstants._instance;
    }
}
